export default "__VITE_PUBLIC_ASSET__8e954e81__"